import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
,
  standalone: false
})
export class FooterComponent implements OnInit {
  showHead: boolean = false;
  currentYear:any;
  releaseVersion:string = environment.releaseVersion;
  constructor(
    private router: Router,
    public extauthService: AuthenticationService,
  ) { 
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event['url'] == '/login' || event['url'] == '/' || event['url'].includes('/login')) {
          this.showHead = false;
        } else {
          this.showHead = true;
        }
      }
    });

    if(this.extauthService && this.extauthService.getHeadingEnabled() && this.extauthService.getHeadingEnabled().subscribe ){
    this.extauthService?.getHeadingEnabled().subscribe((resp:any)=>{
      this.showHead = resp?.setHeadingEnabled
    });
  }
  }

  ngOnInit(){
    this.currentYear =  new Date().getFullYear()
  }

}
